import { adminServerInstance } from "../axios/instances";
import { DELIVERY_AREA as type } from "./deliveryAreaTypes";
import axios from "axios";
import {getUserPreference} from "../utilities/common";

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.zone_name - Zone name
 * @param {string} params.zone_type - Zone type
 * @param {string} params.from_airport - From airport code
 * @param {string} params.to_airport - To airport code
 */
 export function modifyZoneDetailInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.MODIFY_ZONE_DETAIL_INFO})
        return adminServerInstance.post(`/deliveryareatool/modifyzonedetailinfo`, params)
        .then(({data}) => {
            dispatch({
                type: type.MODIFY_ZONE_DETAIL_INFO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.MODIFY_ZONE_DETAIL_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.id - Zip code ID
 * @param {string} params.zipcode - Zip code
 * @param {string} params.sorting_zone - Sorting zone
 * @param {string} params.city - Warehouse ID
 * @param {string} params.owner - Airport code
 * @param {number} params.is_remote - 0->notRemote and 1->remote
 * @param {string} params.route_no - Service NO.
 * @param {string} params.price - Price input 
 * @param {number} params.is_enabled - 0->disabled and 1->enabled
 */
export function handleRowValues(params) {
    return function(dispatch){
    dispatch({type: type.HANDLE_ROW_VALUES})
    return (
        dispatch({
            type: type.HANDLE_ROW_VALUES,
            payload: params
        })
    )}
}

export function getPartners() {   
    return function(dispatch) {
        dispatch({type: type.GET_PARTNERS})
        return adminServerInstance.get(`business/getpartners`)
        .then(({data}) => {
            dispatch({
                type: type.GET_PARTNERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_PARTNERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {file} file - EXCEL file
 */
export function updateZipCodesExcel(file,pattern,city) {
    return function(dispatch) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('pattern', pattern);
        formData.append('warehouse', city);
        dispatch({type: type.UPDATE_ZIP_CODES_EXCEL})
        return adminServerInstance.post('/deliveryareatool/updatezipcodesfromexcel',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        .then(({data}) => {
            dispatch({
                type: type.UPDATE_ZIP_CODES_EXCEL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.UPDATE_ZIP_CODES_EXCEL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.zipcodes - Zip code ID
 * @param {number} params.is_enabled - 0->disabled and 1->enabled
 */
export function enableZipCodes(params) {   
    return function(dispatch) {
        dispatch({type: type.ENABLE_ZIP_CODES})
        return adminServerInstance.put(`/deliveryareatool/enablezipcodes`, {...params})
        .then(({data}) => {
            dispatch({
                type: type.ENABLE_ZIP_CODES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.ENABLE_ZIP_CODES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.id - Zip code ID
 * @param {string} params.zipcode - Zip code
 * @param {string} params.route_no - Service NO.
 * @param {string} params.sorting_zone - Sorting zone
 * @param {string} params.city - Warehouse ID
 * @param {string} params.owner - Airport code
 * @param {number} params.is_remote - 0->notRemote and 1->remote
 * @param {string} params.route_no - Service NO.
 * @param {string} params.price - Price input
 * @param {number} params.is_enabled - 0->disabled and 1->enabled
 */
export function modifyZipCodeInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.MODIFY_ZIP_CODE_INFO})
        return adminServerInstance.post(`/deliveryareatool/modifyzipcodeinfo`, params)
        .then(({data}) => {
            dispatch({
                type: type.MODIFY_ZIP_CODE_INFO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.MODIFY_ZIP_CODE_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
* @param {Object} params - combined object to send for server processing
* @param {string} params.zipcode - Zip code
* @param {string} params.route_no - Service NO.
* @param {string} params.sorting_zone - Sorting zone
* @param {string} params.city - Warehouse ID
* @param {string} params.owner - Airport code
* @param {number} params.is_remote - 0->notRemote and 1->remote
* @param {string} params.route_no - Service NO.
* @param {string} params.price - Price input
* @param {number} params.is_enabled - 0->disabled and 1->enabled
*/
export function addzipcode(params) {
    return function(dispatch) {
        dispatch({type: type.ADD_ZIP_CODE_INFO})
        return adminServerInstance.post(`/deliveryareatool/zipcode/creation`, params)
            .then(({data}) => {
                dispatch({
                    type: type.ADD_ZIP_CODE_INFO_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.ADD_ZIP_CODE_INFO_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.zone_name - Zone name
 * @param {string} params.zone_type - Zone type
 * @param {string} params.from_airport - From airport code
 * @param {string} params.to_airport - To airport code
 */
export function addNewZone(params) {   
    return function(dispatch) {
        dispatch({type: type.ADD_NEW_ZONE})
        return adminServerInstance.post(`/deliveryareatool/addnewzone`, params)
        .then(({data}) => {
            dispatch({
                type: type.ADD_NEW_ZONE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.ADD_NEW_ZONE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getPartnersWarehouse() {   
    return function(dispatch) {
        dispatch({type: type.GET_PARTNERS_WAREHOUSE})
        return adminServerInstance.get(`/deliveryareatool/getpartnerswarehouse`)
        .then(({data}) => {
            dispatch({
                type: type.GET_PARTNERS_WAREHOUSE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_PARTNERS_WAREHOUSE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.partner_id - Partner ID
 * @param {string} params.city - Warehouse ID
 */
export function modifyPartnersWarehouse(params) {   
    return function(dispatch) {
        dispatch({type: type.MODIFY_PARTNERS_WAREHOUSE})
        return adminServerInstance.post(`/deliveryareatool/modifypartnerswarehouse`, params)
        .then(({data}) => {
            dispatch({
                type: type.MODIFY_PARTNERS_WAREHOUSE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.MODIFY_PARTNERS_WAREHOUSE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getAllAirport() {   
    return function(dispatch) {
        dispatch({type: type.GET_ALL_AIRPORT})
        return adminServerInstance.get(`/deliveryareatool/getallairport`)
        .then(({data}) => {
            dispatch({
                type: type.GET_ALL_AIRPORT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_ALL_AIRPORT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.zone_name - Zone name
 * @param {number} params.is_active - 0->deactivated and 1->activated
 */
export function modifyZoneState(params) {   
    return function(dispatch) {
        dispatch({type: type.MODIFY_ZONE_STATE})
        return adminServerInstance.post(`/deliveryareatool/modifyzonestate`, params)
        .then(({data}) => {
            dispatch({
                type: type.MODIFY_ZONE_STATE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.MODIFY_ZONE_STATE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.from_airport - From airport code
 * @param {string} params.to_airport - To airport code
 * @param {string} params.zone_type - Zone type
 * @param {string} params.zone_name - Zone name
 */
export function getAllZone(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_ALL_ZONE})
        return adminServerInstance.get(`/deliveryareatool/getallzone`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_ALL_ZONE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_ALL_ZONE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse - Warehouse ID
 * @param {string} params.is_enabled - 0->disabled and 1->enabled
 * @param {string} params.parttern_id - Parttern ID
 * @param {string} params.zipcode - Zip code
 */
export function getAllZipCodes(params) {   
    return function(dispatch) {
        dispatch({type: type.GET_ALL_ZIP_CODES})
        return adminServerInstance.get(`/deliveryareatool/getallzipcodes`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.GET_ALL_ZIP_CODES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.GET_ALL_ZIP_CODES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 *
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse - Warehouse ID
 * @param {string} params.is_enabled - 0->disabled and 1->enabled
 * @param {string} params.parttern_id - Parttern ID
 * @param {string} params.zipcode - Zip code
 */
export function downloadZipCodeExcelBlob(params) {
    return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/deliveryareatool/dowloadzipcodes`, params, {
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${getUserPreference().authToken}`
        },
        timeout: 0
    })
        .then((response) => {
            if (response.headers['content-type'] === "application/json") {
                return Promise.reject(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ZipCodes.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        })
        .catch((error) => {
            return Promise.reject(error);
        })
}